import { Inject, Injectable } from '@angular/core';
import { SLIDESHOW_REPOSITORY } from '../token/slideshow.token';
import { ISlideshowRepository } from '../../domain/repository/slideshow.respository';
import { TFromData } from 'file-upload';
import { Slideshow } from '../../domain/entity/slideshow.entity';

@Injectable()
export class SlideshowApplication {
  constructor(
    @Inject(SLIDESHOW_REPOSITORY) private repo: ISlideshowRepository,
  ) {}
  getSlideshow() {
    return this.repo.getSlideshow();
  }
  getSlideshowById(id: number) {
    return this.repo.getSlideshowById(id);
  }
  updateSlideshow(slideshow: TFromData<Slideshow>, id: number) {
    return this.repo.updateSlideshow(slideshow, id);
  }
}
